// extracted by mini-css-extract-plugin
export default {"orgChartTrigger":"OrgChartTriggerButton_orgChartTrigger__jMnfL"};